<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Solicitudes ordenes físicas</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Panel de control</span>
    </div>
  </div>

  <div class="d-flex my-xl-auto right-content align-items-center gap-2 flex-wrap">
    <button class="btn btn-secondary header-add-btn" type="button" (click)="nuevaSolicitud()">Nueva solicitud</button>
  </div>
</div>

<div class="row row-sm">
  <div class="col-xl-12">
    <div class="card overflow-visible solicitudes-hero">
      <div class="card-body hero-body">
        <div class="hero-left">
          <p class="hero-kicker">Gestión operativa</p>
          <h5 class="hero-title mb-1">Panel de solicitudes de órdenes físicas</h5>
          <p class="hero-subtitle mb-0">Consulta, filtra y visualiza asignaciones 2D por solicitud.</p>
        </div>
        <div class="hero-right">
          <div class="metric-card">
            <span class="metric-label">Solicitudes</span>
            <b class="metric-value">{{ totalSolicitudes }}</b>
          </div>
          <div class="metric-card">
            <span class="metric-label">Órdenes</span>
            <b class="metric-value">{{ totalOrdenes }}</b>
          </div>
          <div class="metric-card">
            <span class="metric-label">Blocks</span>
            <b class="metric-value">{{ totalBlocks }}</b>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xl-12">
    <div class="card overflow-visible filter-card">
      <div class="card-body">
        <h6 class="filter-title">Buscar por secuencia</h6>
        <div class="filter-row">
          <input type="text" class="form-control filter-input" [(ngModel)]="txtSecuencia" placeholder="Ejemplo: A100 o 000050001">
          <button class="btn btn-secondary" type="button" (click)="buscarSecuencia()" [disabled]="buscando">
            {{ buscando ? 'Buscando...' : 'Buscar' }}
          </button>
          <button class="btn btn-light" type="button" (click)="txtSecuencia=''; obtenerSolicitudes()" [disabled]="cargando || buscando">
            Limpiar
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xl-12">
    <div class="card overflow-visible table-card">
      <div class="card-body">
        @if (cargando) {
          <div class="text-center py-4">
            <div class="spinner-grow" role="status"></div>
            <p class="mt-2 mb-0">Consultando solicitudes, por favor espere...</p>
          </div>
        }

        @if (!cargando && solicitudes.length === 0) {
          <div class="empty-state">
            <div class="empty-state__icon">
              <i class="fa fa-copy"></i>
            </div>
            <h5>No hay solicitudes registradas</h5>
            <p>Cuando existan solicitudes de órdenes físicas aparecerán aquí.</p>
          </div>
        }

        @if (!cargando && solicitudes.length > 0) {
          <div class="table-responsive d-none d-md-block">
            <table datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover dt-ext solicitudes-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Secuencial</th>
                  <th>Ordenes solicitadas</th>
                  <th>Blocks</th>
                  <th>Fecha</th>
                  <th>Tipo precio</th>
                  <th>Responsable</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                @for (solicitud of solicitudes; track solicitud; let i = $index) {
                  <tr>
                    <td>{{ i + 1 }}</td>
                    <td><span class="sec-badge">{{ solicitud.SEC_SOLORD }}</span></td>
                    <td>{{ solicitud.TOT_SOLORD }}</td>
                    <td>{{ (solicitud.TOT_SOLORD || 0) / 25 }}</td>
                    <td>{{ solicitud.FEC_SOLORD ? (solicitud.FEC_SOLORD | date:'dd/MM/yyyy hh:mm a') : '-' }}</td>
                    <td>{{ solicitud.DES_TIPPREC }}</td>
                    <td>{{ solicitud.RES_SOLORD }}</td>
                    <td>
                      <button class="btn btn-outline-secondary btn-sm" type="button" (click)="verAsignaciones2D(mdlVerDetalle, solicitud)">
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }

        @if (!cargando && solicitudes.length > 0) {
          <div class="mobile-list d-md-none">
            @for (solicitud of solicitudes; track solicitud; let i = $index) {
              <article class="mobile-card">
                <div class="mobile-card__head">
                  <span class="mobile-index">#{{ i + 1 }}</span>
                  <span class="mobile-date">
                    {{ solicitud.FEC_SOLORD ? (solicitud.FEC_SOLORD | date:'dd/MM/yyyy hh:mm a') : '-' }}
                  </span>
                </div>
                <div class="mobile-card__title">{{ solicitud.SEC_SOLORD }}</div>
                <div class="mobile-card__meta">
                  <div><span>Órdenes:</span> <b>{{ solicitud.TOT_SOLORD }}</b></div>
                  <div><span>Blocks:</span> <b>{{ (solicitud.TOT_SOLORD || 0) / 25 }}</b></div>
                  <div><span>Tipo:</span> <b>{{ solicitud.DES_TIPPREC }}</b></div>
                  <div><span>Responsable:</span> <b>{{ solicitud.RES_SOLORD }}</b></div>
                </div>
                <div class="mobile-card__actions">
                  <button class="btn btn-outline-secondary btn-sm" type="button" (click)="verAsignaciones2D(mdlVerDetalle, solicitud)">
                    Ver asignaciones
                  </button>
                </div>
              </article>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #mdlVerDetalle let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Asignaciones Precios 2D</h6>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="table-responsive">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>N. de Blocks</th>
            <th>Precio</th>
            <th>Asignaciones</th>
            <th>Disponibles</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          @for (item of detalle2D; track item) {
            <tr>
              <td>{{ item.numeroBlocks }}</td>
              <td>{{ item.precios2D | currency:'USD':'symbol':'1.2-2' }}</td>
              <td>{{ item.secuencia }}</td>
              <td>{{ item.disponibles }}</td>
              <td>
                <button class="btn btn-secondary btn-sm" type="button" (click)="visualizarAsignacion(item)">
                  Visualizar
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss('cancel')">Salir</button>
  </div>
</ng-template>
